export default {
  login: {
    welcome: 'Xoş gəlmisiniz',
    subtitle: 'Alış-verişə davam etmək üçün daxil olun',
    phonePlaceholder: 'Telefon nömrənizi daxil edin',
    passwordPlaceholder: 'Şifrəni daxil edin',
    showPassword: 'Göstər',
    hidePassword: 'Gizlət',
    loginButton: 'Daxil ol',
    registerButton: 'Pulsuz qeydiyyat',
    title: 'Daxil ol',
    subtitle2: 'Qlobal alış-veriş və mükafatlar bir yerdə',
    logging: 'Daxil olunur...',
    phoneRequired: 'Lütfən telefon nömrənizi daxil edin',
    passwordRequired: 'Lütfən şifrəni daxil edin',
    loginSuccess: 'Uğurla daxil oldunuz',
    loginFailed: 'Giriş uğursuz oldu',
    loginError: 'Giriş xətası, lütfən sonra yenidən cəhd edin'
  },
  register: {
    title: 'Hesab yaradın',
    subtitle: 'Bizə qoşulun və ticarət səyahətinizə başlayın',
    username: 'İstifadəçi adı',
    phone: 'Telefon nömrəsi',
    loginPassword: 'Giriş şifrəsi',
    transactionPassword: 'Əməliyyat şifrəsi',
    invitationCode: 'Dəvət kodu',
    usernamePlaceholder: 'İstifadəçi adını daxil edin',
    phonePlaceholder: 'Telefon nömrəsini daxil edin',
    loginPasswordPlaceholder: 'Giriş şifrəsini daxil edin',
    transactionPasswordPlaceholder: 'Əməliyyat şifrəsini daxil edin',
    invitationCodePlaceholder: 'Dəvət kodunu daxil edin',
    registerButton: 'Qeydiyyatdan keç',
    hasAccount: 'Artıq hesabınız var? Daxil olun',
    errorUsername: 'Lütfən istifadəçi adını daxil edin',
    errorPhone: 'Lütfən telefon nömrəsini daxil edin',
    errorLoginPassword: 'Lütfən giriş şifrəsini daxil edin',
    errorTransactionPassword: 'Lütfən əməliyyat şifrəsini daxil edin',
    errorInviteCode: 'Lütfən dəvət kodunu daxil edin',
    registerSuccess: 'Qeydiyyat uğurla tamamlandı'
  },
  tabbar: {
    home: 'Əsas səhifə',
    purchase: 'Sifariş tarixçəsi',
    grabbing: 'Sifariş ver',
    kefu: 'Müştəri xidməti',
    my: 'Mənim'
  },
  home: {
    orderCount: 'Sifarişlərin sayı',
    upgradeAmount: 'Yeniləmək üçün doldur',
    recharge: 'Balansı artır',
    withdraw: 'Çıxarış',
    team: 'Komanda idarəetməsi',
    commission: 'Komissiya al',
    newProducts: 'Yeni məhsullar',
    newProductsDesc: 'Yeni mövsüm və gələcək kolleksiyaların ən son modelləri.',
    buyNow: 'İndi al',
    nowAvailable: 'İndi satışda',
    nowAvailableDesc: 'Toy mövsümünə hazırlaşın, növbəti səyahətiniz üçün əşyalarınızı yığın və qarderobunuzu öhdəlik olmadan yeniləyin. Yeni icarə proqramımızla siz ən son trendləri sınaya və abunə olmadan büdcənizə sadiq qala bilərsiniz.',
    footerTitle: 'Desigual.com',
    footerFollow: "Bizi izləyin {'@'}Desigual.com və ən sevdiyiniz Desigual.com görünüşlərini paylaşın!",
    footerShop: 'Lentimizi nəzərdən keçirin'
  },
  purchase: {
    all: 'Hamısı',
    pending: 'Gözləmədə',
    completed: 'Tamamlanıb',
    frozen: 'Dondurulub',
    balance: 'Hesab balansı',
    orderTime: 'Sifariş vaxtı',
    orderId: 'Sifariş nömrəsi',
    totalAmount: 'Sifarişin ümumi məbləği',
    commission: 'Komissiya',
    expectedReturn: 'Gözlənilən gəlir',
    submitOrder: 'Sifarişi təsdiqlə',
    orderCompleted: 'Sifariş tamamlandı',
    loading: 'Yüklənir...',
    noData: 'Sifariş məlumatı yoxdur',
    noMore: 'Başqa məlumat yoxdur',
    orderSuccess: 'Sifariş uğurla götürüldü',
    orderNumber: 'Sifariş nömrəsi',
    rating: 'Qiymətləndirmə',
    notSubmit: 'Hələ təqdim etmə',
    submitNow: 'İndi təqdim et',
    submitting: 'Təqdim edilir...',
    submitFailed: 'Təqdimetmə uğursuz oldu',
    grabOrderFailed: 'Sifariş götürmək xətası, lütfən sonra yenidən cəhd edin',
    getOrderInfoFailed: 'Sifariş detallarını əldə etmək alınmadı',
    submitOrderFailed: 'Təqdimetmə xətası, lütfən sonra yenidən cəhd edin'
  },
  common: {
    home: 'Əsas səhifə',
    about: 'Haqqında',
    contact: 'Bizimlə əlaqə',
    purchase: 'Sifariş tarixçəsi',
    grabbing: 'Sifariş ver',
    my: 'Mənim',
    login: 'Daxil ol',
    register: 'Qeydiyyat',
    kefu: 'Müştəri xidməti',
    loadDataError: 'Məlumatı yükləmək alınmadı, lütfən sonra yenidən cəhd edin',
    success: 'Əməliyyat uğurludur',
    failed: 'Əməliyyat uğursuz oldu',
    submitSuccess: 'Uğurla təqdim edildi',
    submitFailed: 'Təqdimetmə uğursuz oldu',
    submitting: 'Təqdim edilir...'
  },
  grabbing: {
    accountAmount: 'Hesab məbləği',
    accountBalance: 'Hesab balansı',
    getCommission: 'Komissiya al',
    ordersGrabbedToday: 'Bu gün götürülən sifarişlər',
    orderCount: 'Sifariş sayı',
    operationSteps: 'Əməliyyat addımları',
    step1: '1. Tapşırığı başlamaq üçün düyməni sıxın və təlimatlara əməl edin',
    step2: '2. Tapşırığı bitirdikdən sonra komissiyanı balansınıza əlavə edə bilərsiniz',
    grabOrder: 'Sifarişi götür',
    pleaseWait: 'Lütfən gözləyin',
    grabSuccess: 'Sifariş uğurla götürüldü',
    grabTime: 'Sifariş vaxtı',
    grabNumber: 'Sifariş nömrəsi',
    orderTotal: 'Sifarişin cəmi',
    commission: 'Komissiya',
    expectedReturn: 'Gözlənilən gəlir',
    rating: 'Qiymətləndirmə',
    notSubmit: 'Hələ təqdim etmə',
    submitNow: 'İndi təqdim et',
    submitting: 'Təqdim edilir...'
  },
  kefu: {
    title: 'Müştəri xidməti',
    intro: {
      line1: 'Hər hansı bir sualınız varsa və ya köməyə ehtiyacınız varsa,',
      line2: 'lütfən həll üçün onlayn müştəri xidməti ilə əlaqə saxlayın'
    },
    serviceTime: {
      label: 'Xidmət vaxtı',
      text: 'Sizin xüsusi müştəri xidmətiniz',
      online: 'Onlayn'
    },
    contact: {
      title: 'Əlaqə',
      name: 'Onlayn',
      status: 'Məsləhətləşmə',
      feature1: 'Dərhal cavab',
      feature2: 'Peşəkar xidmət',
      button: 'Əlaqə'
    },
    faq: {
      title: 'Tez-tez verilən suallar',
      rechargeQuestion: 'Balansı necə artırmaq olar?',
      rechargeAnswer: 'Təhlükəsiz ödəniş şlüzümüz vasitəsilə balansı artıra bilərsiniz. Mənim Hesabım > Balansı artır bölməsinə gedin və təlimatlara əməl edin.',
      withdrawQuestion: 'Pulu necə çıxarmaq olar?',
      withdrawAnswer: 'Çıxarışları Mənim Hesabım > Çıxarış vasitəsilə etmək olar. Hesabınızın təsdiqləndiyindən əmin olun.',
      minRechargeQuestion: 'Minimum artırma məbləği nə qədərdir?',
      minRechargeAnswer: 'Minimum artırma məbləği ${currency}68-dir.',
      withdrawTimeQuestion: 'Çıxarış nə qədər vaxt aparır?',
      withdrawTimeAnswer: 'Çıxarışlar adətən 24 saat ərzində həyata keçirilir.',
      securityQuestion: 'Mənim məlumatlarım təhlükəsizdirmi?',
      securityAnswer: 'Bəli, şəxsi və maliyyə məlumatlarınızı qorumaq üçün sənaye standartı olan şifrələmə texnologiyalarından istifadə edirik.'
    }
  },
  my: {
    inviteCode: 'Dəvət kodu',
    copy: 'Kopyala',
    copySuccess: 'Uğurla kopyalandı',
    copyFailed: 'Kopyalamaq alınmadı',
    online: 'Onlayn',
    accountBalance: 'Hesab məbləği',
    balance: 'Hesab balansı',
    accountBalanceTrend: 'Hesab balansı trendi',
    todayCommission: 'Bugünkü komissiya',
    totalCommission: 'Ümumi komissiya',
    today: 'Bu gün',
    total: 'Ümumi',
    todayOrders: 'Bu gün götürülən sifarişlər',
    orderCount: 'Sifariş sayı',
    recharge: 'Balansı artır',
    withdraw: 'Çıxarış',
    rechargeRecord: 'Artırma tarixçəsi',
    withdrawRecord: 'Çıxarış tarixçəsi',
    accountDetails: 'Hesab detalları',
    receivingAccount: 'Qəbul edən hesab',
    bankAccount: 'Bank hesabı',
    bankAccountDesc: 'Bank hesabı',
    usdt: 'USDT',
    usdtDesc: 'USDT ünvanı',
    connect: 'Bağlan',
    teamManagement: 'Komanda idarəetməsi',
    viewTeam: 'Komandaya bax',
    changePassword: 'Şifrəni dəyiş',
    changeWithdrawPassword: 'Çıxarış şifrəsini dəyiş',
    passwordSettings: 'Şifrə tənzimləmələri',
    logout: 'Çıxış',
    signOut: 'Sistemdən çıx',
    version: 'Versiya'
  },
  changePasswordPage: {
    currentPassword: 'Cari giriş şifrəsi',
    currentPasswordPlaceholder: 'Cari şifrəni daxil edin',
    newPassword: 'Yeni giriş şifrəsi',
    newPasswordPlaceholder: 'Yeni şifrəni daxil edin',
    confirmPassword: 'Giriş şifrəsini təsdiqlə',
    confirmPasswordPlaceholder: 'Yeni şifrəni təsdiqləyin',
    notice: 'Giriş şifrəsi hesaba daxil olmaq üçün istifadə olunur. Şifrə təhlükəsizliyi təmin etmək üçün ən azı 6 simvoldan ibarət olmalı və həm hərflər, həm də rəqəmlər daxil etməlidir.',
    updateButton: 'Giriş şifrəsini yenilə',
    errorOldPassword: 'Lütfən cari şifrəni daxil edin',
    errorNewPassword: 'Lütfən yeni şifrəni daxil edin',
    errorConfirmPassword: 'Lütfən yeni şifrəni təsdiqləyin',
    errorPasswordMismatch: 'Daxil edilən şifrələr uyğun gəlmir',
    errorPasswordLength: 'Şifrə ən azı 6 simvoldan ibarət olmalıdır',
    errorPasswordFormat: 'Şifrədə hərflər və rəqəmlər olmalıdır'
  },
  changeWithdrawPasswordPage: {
    currentPassword: 'Cari çıxarış şifrəsi',
    currentPasswordPlaceholder: 'Cari çıxarış şifrəsini daxil edin',
    newPassword: 'Yeni çıxarış şifrəsi',
    newPasswordPlaceholder: 'Yeni çıxarış şifrəsini daxil edin',
    confirmPassword: 'Çıxarış şifrəsini təsdiqlə',
    confirmPasswordPlaceholder: 'Yeni çıxarış şifrəsini təsdiqləyin',
    notice: 'Çıxarış şifrəsi vəsaitlərin çıxarılması üçün istifadə olunur. Şifrə təhlükəsizliyi təmin etmək üçün ən azı 6 simvoldan ibarət olmalı və həm hərflər, həm də rəqəmlər daxil etməlidir.',
    updateButton: 'Çıxarış şifrəsini yenilə',
    errorOldPassword: 'Lütfən cari çıxarış şifrəsini daxil edin',
    errorNewPassword: 'Lütfən yeni çıxarış şifrəsini daxil edin',
    errorConfirmPassword: 'Lütfən yeni çıxarış şifrəsini təsdiqləyin',
    errorPasswordMismatch: 'Daxil edilən şifrələr uyğun gəlmir',
    errorPasswordLength: 'Şifrə ən azı 6 simvoldan ibarət olmalıdır',
    errorPasswordFormat: 'Şifrədə hərflər və rəqəmlər olmalıdır'
  },
  details: {
    loading: 'Yüklənir...',
    noRecords: 'Heç bir qeyd yoxdur',
    noMore: 'Başqa məlumat yoxdur',
    time: 'Vaxt',
    type: 'Növ',
    amount: 'Məbləğ',
    balance: 'Balans',
    remark: 'Qeyd',
    type0: 'Digər',
    type1: 'Balansı artır',
    type2: 'Çıxarış',
    type3: 'Əməliyyat',
    type4: 'Sifariş komissiyası',
    type5: 'Alt səviyyə güzəşti',
    type8: 'Çıxarış rədd edildi'
  },
  rechargeRecord: {
    offline: 'Oflayn artırma',
    online: 'Onlayn artırma',
    loading: 'Yüklənir...',
    noRecords: 'Heç bir qeyd yoxdur',
    orderNo: 'Sifariş nömrəsi',
    rechargeAmount: 'Artırma məbləği',
    rechargeTime: 'Artırma vaxtı',
    payMethod: 'Ödəniş üsulu',
    rechargeStatus: 'Artırma statusu',
    noMore: 'Başqa məlumat yoxdur',
    statusPending: 'Baxışda',
    statusApproved: 'Təsdiqləndi',
    statusFailed: 'Uğursuz oldu',
    statusEmpty: ''
  },
  withdrawRecord: {
    loading: 'Yüklənir...',
    noRecords: 'Heç bir qeyd yoxdur',
    orderNo: 'Sifariş nömrəsi',
    withdrawAmount: 'Çıxarış məbləği',
    withdrawTime: 'Çıxarış vaxtı',
    withdrawAddress: 'Çıxarış ünvanı',
    withdrawStatus: 'Çıxarış statusu',
    noMore: 'Başqa məlumat yoxdur',
    statusPending: 'İşlənir',
    statusApproved: 'Uğurlu oldu',
    statusFailed: 'Uğursuz oldu',
    statusEmpty: ''
  },
  withdraw: {
    title: 'Çıxarış',
    method: 'Çıxarış üsulu',
    methodSubtitle: 'Lütfən çıxarış üsulunuzu seçin',
    bankInfo: 'Bank hesabı məlumatı',
    bankName: 'Bankın adı',
    accountHolder: 'Hesab sahibi',
    bankCard: 'Bank kartı',
    amount: 'Çıxarış məbləği',
    balance: 'Balans',
    withdrawAll: 'Hamısını çıxar',
    paymentPassword: 'Ödəniş şifrəsi',
    passwordPlaceholder: 'Lütfən vəsait şifrəsini daxil edin',
    principal: 'Əsas məbləğ',
    serviceFee: 'Xidmət haqqı',
    netAmount: 'Xalis məbləğ',
    notice: '*Lütfən qəbuledici məlumatlarını diqqətlə yoxlayın',
    withdrawButton: 'Çıxarış',
    walletAddress: 'Cüzdan ünvanı',
    walletAddressSubtitle: 'Lütfən cüzdan ünvanını daxil edin'
  },
  recharge: {
    title: 'Balansı artır',
    amount: 'Artırma məbləği',
    amountSubtitle: 'Lütfən artırmaq istədiyiniz məbləği daxil edin',
    quickSelect: 'Sürətli seçim',
    rechargeNow: 'İndi artır',
    selectPayment: 'Ödəniş üsulunu seçin',
    selectPaymentSubtitle: 'Lütfən üstünlük verdiyiniz ödəniş üsulunu seçin',
    cancel: 'Ləğv et',
    confirm: 'Təsdiq et',
    crypto: 'Kriptovalyuta',
    bank: 'Bank köçürməsi',
    paymentRange: 'Minimum: {symbol}{minAmount} - Maksimum: {symbol}{maxAmount}',
    rechargeFailed: 'Artırma uğursuz oldu',
    paymentInfo: 'Ödəniş məlumatı',
    usercode: 'USDT ünvanı',
    uploadScreenshot: 'Lütfən ödəniş skrinşotunu təqdim edin',
    clickToUpload: 'Skrinşot yükləmək üçün klikləyin',
    copySuccess: 'Uğurla kopyalandı',
    copyFailed: 'Kopyalamaq alınmadı',
    uploadScreenshotRequired: 'Lütfən ödəniş skrinşotunu yükləyin',
    submit: 'Təqdim et',
    submitting: 'Təqdim edilir...',
    submitSuccess: 'Uğurla təqdim edildi',
    submitFailed: 'Təqdimetmə uğursuz oldu'
  },
  bindUsdt: {
    title: 'USDT bağla',
    cardTitle: 'USDT ünvanı',
    cardSubtitle: 'USDT cüzdan ünvanınızı daxil edin',
    walletAddress: 'Cüzdan ünvanı',
    walletAddressPlaceholder: 'Lütfən USDT cüzdan ünvanını daxil edin',
    networkType: 'Şəbəkə növü',
    networkTypePlaceholder: 'Lütfən şəbəkə növünü seçin',
    withdrawPassword: 'Çıxarış şifrəsi',
    withdrawPasswordPlaceholder: 'Lütfən çıxarış şifrəsini daxil edin',
    trc20: 'TRC20',
    trc20Network: 'TRC20 şəbəkəsi',
    erc20: 'ERC20',
    erc20Network: 'ERC20 şəbəkəsi',
    securityNotice: 'Təhlükəsizlik xəbərdarlığı',
    securityText1: '• Sizin USDT ünvanınız şifrələnmiş və təhlükəsiz şəkildə saxlanılır',
    securityText2: '• Bu məlumatı yalnız siz görə və dəyişdirə bilərsiniz',
    securityText3: '• Bütün məlumatların düzgün olduğundan əmin olun',
    buttonText: 'Məlumatı yadda saxla',
    buttonSubtitle: 'USDT ünvanını bağla',
    errorWalletAddress: 'Lütfən cüzdan ünvanını daxil edin',
    errorNetworkType: 'Lütfən şəbəkə növünü seçin',
    errorWithdrawPassword: 'Lütfən çıxarış şifrəsini daxil edin'
  },
  team: {
    title: 'Komanda idarəetməsi',
    level1: 'Səviyyə 1 Komanda',
    level2: 'Səviyyə 2 Komanda',
    level3: 'Səviyyə 3 Komanda',
    level1Members: 'Səviyyə 1 Üzvləri',
    level2Members: 'Səviyyə 2 Üzvləri',
    level3Members: 'Səviyyə 3 Üzvləri',
    totalMembers: 'Ümumi üzvlər',
    totalCommission: 'Ümumi komissiya',
    members: 'nəfər',
    orders: 'sifarişlər',
    commission: 'Komissiya',
    noMembers: 'Hələ üzv yoxdur',
    loading: 'Yüklənir...',
    noMore: 'Başqa məlumat yoxdur'
  },
  bindBank: {
    title: 'Bank kartını bağla',
    cardTitle: 'Bank məlumatı',
    cardSubtitle: 'Bankınızı seçin və hesab detallarını daxil edin',
    bankName: 'Bankın adı',
    bankNamePlaceholder: 'Lütfən bankın adını daxil edin',
    cardNumber: 'Kart nömrəsi',
    cardNumberPlaceholder: 'Lütfən kart nömrəsini daxil edin',
    realName: 'Əsl ad',
    realNamePlaceholder: 'Lütfən əsl adınızı daxil edin',
    withdrawPassword: 'Çıxarış şifrəsi',
    withdrawPasswordPlaceholder: 'Lütfən çıxarış şifrəsini daxil edin',
    securityNotice: 'Təhlükəsizlik xəbərdarlığı',
    securityText1: '• Bank məlumatlarınız şifrələnmiş və təhlükəsiz şəkildə saxlanılır',
    securityText2: '• Bu məlumatı yalnız siz görə və dəyişdirə bilərsiniz',
    securityText3: '• Bütün məlumatların düzgün olduğundan əmin olun',
    buttonText: 'Məlumatı yadda saxla',
    buttonSubtitle: 'Bank hesabını bağla',
    errorBankName: 'Lütfən bankın adını daxil edin',
    errorCardNumber: 'Lütfən kart nömrəsini daxil edin',
    errorRealName: 'Lütfən əsl adınızı daxil edin',
    errorWithdrawPassword: 'Lütfən çıxarış şifrəsini daxil edin'
  }
}